declare global {
  interface Window {
    SocureInitializer?: any
    SigmaDeviceManager?: {
      getSessionToken: () => Promise<string>
    }
  }
}

export const loadSocureSdk = () => {
  const coreCall = window.document.createElement('script')
  coreCall.src = 'https://websdk.socure.com/bundle.js'
  coreCall.defer = true
  window.document.body
    ? window.document.body.appendChild(coreCall)
    : window.document.head.appendChild(coreCall)
}

export const isSocureSdkLoaded = () => {
  return !!window.SocureInitializer
}

export const loadSocureDeviceRiskSdk = (publicKey: string) => {
  if (window.SigmaDeviceManager) {
    return
  }

  const script = window.document.createElement('script')
  script.src = 'https://sdk.dv.socure.io/latest/device-risk-sdk.js'
  script.setAttribute('data-public-key', publicKey)
  script.async = true
  window.document.head.appendChild(script)
}
